/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PurchaseItemType } from './PurchaseItemType';
import {
    PurchaseItemTypeFromJSON,
    PurchaseItemTypeFromJSONTyped,
    PurchaseItemTypeToJSON,
} from './PurchaseItemType';

/**
 * 
 * @export
 * @interface PurchaseItem
 */
export interface PurchaseItem {
    /**
     * 
     * @type {string}
     * @memberof PurchaseItem
     */
    productId: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseItem
     */
    additionalId?: string;
    /**
     * 
     * @type {PurchaseItemType}
     * @memberof PurchaseItem
     */
    type: PurchaseItemType;
    /**
     * 
     * @type {number}
     * @memberof PurchaseItem
     */
    quantity: number;
}

/**
 * Check if a given object implements the PurchaseItem interface.
 */
export function instanceOfPurchaseItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "quantity" in value;

    return isInstance;
}

export function PurchaseItemFromJSON(json: any): PurchaseItem {
    return PurchaseItemFromJSONTyped(json, false);
}

export function PurchaseItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productId': json['productId'],
        'additionalId': !exists(json, 'additionalId') ? undefined : json['additionalId'],
        'type': PurchaseItemTypeFromJSON(json['type']),
        'quantity': json['quantity'],
    };
}

export function PurchaseItemToJSON(value?: PurchaseItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'productId': value.productId,
        'additionalId': value.additionalId,
        'type': PurchaseItemTypeToJSON(value.type),
        'quantity': value.quantity,
    };
}

